import Grid from "@mui/material/Grid2";
import { Establishment } from "../../interfaces/establishment";
import mazotoLogo from "../../assets/logo_mazoto_simples_transparent.png";
import ImageColumn from "./imageColumn";
import { Typography } from "@mui/material";
import fontColorContrast from "font-color-contrast";

export default function EstablishmentLayout({
  establishment,
  children,
}: {
  establishment: Establishment;
  children?: React.ReactNode;
}) {
  return (
    <Grid container columns={{ xs: 8, sm: 8, md: 12 }}>
      <Grid size={2} sx={{ display: { xs: "none", md: "block" } }}>
        <ImageColumn
          images={establishment.photos}
          take={Math.ceil(establishment.photos.length / 2)}
        />
      </Grid>
      <Grid
        size={8}
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <div
          style={{
            width: "100%",
            height: "10rem",
            backgroundColor: establishment.background_color ?? "#2874A4",
            position: "relative",
          }}
        ></div>
        <Grid
          container
          spacing={3}
          columns={{ xs: 6, sm: 6, md: 12 }}
          sx={{ margin: "3rem", position: "relative", maxWidth: "700px" }}
        >
          <div style={{ position: "relative", width: "100%" }}>
            <img
              style={{
                width: "8rem",
                height: "8rem",
                position: "absolute",
                top: "-10rem",
                objectFit: "cover",
                borderRadius: "4rem",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
              }}
              src={establishment.logo ?? mazotoLogo}
              crossOrigin="anonymous"
              alt="logo"
            />
            <Typography
              sx={{
                position: "absolute",
                left: "9rem",
                top: { md: "-8rem", xs: "-9rem" },
                lineHeight: { md: "2.5rem", xs: "1.5rem" },
                fontSize: { md: "2.5rem", xs: "1.5rem" },
                color: fontColorContrast(
                  establishment.background_color ?? "#2874A4"
                ),
              }}
            >
              {establishment.name}
            </Typography>
            <Typography
              sx={{
                position: "absolute",
                left: "9rem",
                top: "-5.2rem",
                fontSize: "1.2rem",
                color: fontColorContrast(
                  establishment.background_color ?? "#2874A4"
                ),
              }}
            >
              {establishment.phone}
            </Typography>
          </div>
          {children}
        </Grid>
      </Grid>
      <Grid
        size={{ md: 2, xs: 12 }}
      >
        <ImageColumn
          images={establishment.photos}
          columns={window.innerWidth < 768 ? 2 : 1}
          take={window.innerWidth < 768 ? 8 : Math.floor(establishment.photos.length / 2)}
          fromEnd
        />
      </Grid>
    </Grid>
  );
}
